import { render, staticRenderFns } from "./ManterMinuta.vue?vue&type=template&id=7c610e40&scoped=true&"
import script from "./ManterMinuta.vue?vue&type=script&lang=js&"
export * from "./ManterMinuta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c610e40",
  null
  
)

export default component.exports